import { safeExecute, } from "@opendaw/lib-std";
import { Box, NoPointers, PointerField, Field, Int32Field, } from "@opendaw/lib-box";
import { Pointers } from "@opendaw/studio-enums";
export class CompositeCellBox extends Box {
    static create(graph, uuid, constructor) {
        return graph.stageBox(new CompositeCellBox({
            uuid,
            graph,
            name: "CompositeCellBox",
            pointerRules: {
                accepts: [Pointers.Selection],
                mandatory: false,
                exclusive: false,
            },
            resource: undefined,
            ephemeral: false,
        }), constructor);
    }
    static ClassName = "CompositeCellBox";
    static Resource = undefined;
    static Ephemeral = false;
    static Tags = Object.freeze({});
    constructor(construct) {
        super(construct);
    }
    accept(visitor) {
        return safeExecute(visitor.visitCompositeCellBox, this);
    }
    get tags() {
        return CompositeCellBox.Tags;
    }
    get composite() {
        return this.getField(1);
    }
    get instrument() {
        return this.getField(2);
    }
    get midiEffects() {
        return this.getField(3);
    }
    get audioEffects() {
        return this.getField(4);
    }
    get index() {
        return this.getField(5);
    }
    initializeFields() {
        return {
            1: PointerField.create({
                parent: this,
                fieldKey: 1,
                fieldName: "composite",
                deprecated: false,
                pointerRules: NoPointers,
            }, Pointers.CompositeCell, true),
            2: Field.hook({
                parent: this,
                fieldKey: 2,
                fieldName: "instrument",
                deprecated: false,
                pointerRules: {
                    accepts: [Pointers.InstrumentHost],
                    mandatory: true,
                    exclusive: false,
                },
            }),
            3: Field.hook({
                parent: this,
                fieldKey: 3,
                fieldName: "midiEffects",
                deprecated: false,
                pointerRules: {
                    accepts: [Pointers.MIDIEffectHost],
                    mandatory: false,
                    exclusive: false,
                },
            }),
            4: Field.hook({
                parent: this,
                fieldKey: 4,
                fieldName: "audioEffects",
                deprecated: false,
                pointerRules: {
                    accepts: [Pointers.AudioEffectHost],
                    mandatory: false,
                    exclusive: false,
                },
            }),
            5: Int32Field.create({
                parent: this,
                fieldKey: 5,
                fieldName: "index",
                deprecated: false,
                pointerRules: NoPointers,
            }, "index", ""),
        };
    }
}
